var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0673 24.9425L17.4155 5.16125C16.6605 3.75875 14.6492 3.75875 13.8936 5.16125L3.24234 24.9425H3.24234C2.7187 25.9151 3.08263 27.128 4.05519 27.6516C4.34574 27.808 4.67048 27.8902 5.00046 27.8906H26.3061C27.4107 27.8908 28.3062 26.9955 28.3064 25.8909C28.3064 25.5599 28.2243 25.234 28.0673 24.9425V24.9425ZM15.6548 24.8281C14.9645 24.8281 14.4048 24.2685 14.4048 23.5781C14.4048 22.8878 14.9645 22.3281 15.6548 22.3281C16.3452 22.3281 16.9048 22.8878 16.9048 23.5781C16.9048 24.2685 16.3452 24.8281 15.6548 24.8281ZM17.0123 12.2563L16.6536 19.8813C16.6536 20.4335 16.2059 20.8813 15.6536 20.8813C15.1013 20.8813 14.6536 20.4335 14.6536 19.8813L14.2948 12.2594V12.2594C14.2617 11.51 14.8422 10.8757 15.5916 10.8425C15.6072 10.8418 15.6229 10.8414 15.6386 10.8413H15.6517C16.4021 10.8409 17.0108 11.4489 17.0112 12.1993C17.0112 12.2195 17.0107 12.2398 17.0098 12.26L17.0123 12.2563Z",
    fill: "#FF0000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertError);
export default __webpack_public_path__ + "static/media/alert_error.5561115e53aa47cb418b6c78c0a6dd9f.svg";
export { ForwardRef as ReactComponent };